import React from 'react'
import './loadingFlashDeals.css'

function LoadingFlashDeals() {
  return (
    <div className="product_item_flash product mtop loading_product_item"></div>
  )
}

export default LoadingFlashDeals